<lib-dialog-layout>
    <ng-container title i18n="@@CommonUploadProfilePicture">
        Upload Profile Picture
    </ng-container>
    <ng-container content>
        <lib-upload
            (RetrieveFiles)="EmitFiles($event)"
            (RemoveFiles)="EmitFiles($event)"
            [SnackbarAction]="data.SnackbarAction!"
            [acceptedFormat]="data.AcceptedFormat"
            [allowMultiFileUpload]="data.AllowMultiFileUpload"
            [showFormFieldLabel]="false"
            [showAttachmentDialogPreviewerTitle]="false"
            [maxAllowedFilesize]="maxAllowedImageSize"
            [control]="form.controls.ImageToUpload">
        </lib-upload>

    <form [formGroup]="form">
            <lib-radio-group [formControl]="form.controls.UseFaceDetection">
                <ng-container label i18n="@@CommonCrop">
                    Crop
                </ng-container>
                <lib-radio-group-item
                    [value]="ProfileImageCrop.Automatic">
                   <ng-container i18n="@@CommonAvatarAutomaticOption">
                    Automatic
                    </ng-container>
                    <ng-container radioSupportingText i18n="@@CommonAvatarAutomaticOptionHint">
                        Detects and focuses on faces</ng-container>
                </lib-radio-group-item>
                <lib-radio-group-item i18n="@@CommonAvatarCenterOption"
                    [value]="ProfileImageCrop.Center">
                    Center
                </lib-radio-group-item>
            </lib-radio-group>
    </form>
    </ng-container>
    <ng-container submissionBar>
        <lib-submission-bar [kind]="SubmissionBarKind.DialogBasic">
            <lib-button
            [role]="ButtonRole.Primary"
                id="LibraryDialogPrimaryButton"
                [disabled]="!hasFiles"
                [loading]="primaryActionClicked"
                (clicked)="PrimaryAction()">
                <ng-container label i18n="@@CommonUploadButton">
                    Upload
                </ng-container>
            </lib-button>
            <lib-button
            [role]="ButtonRole.Secondary"
                id="LibraryDialogSecondaryButton"
                [kind]="ButtonKind.NeutralSecondary"
                [size]="ButtonSize.Large"
                [disabled]="primaryActionClicked"
                (clicked)="DismissAction()">
                <ng-container label i18n="@@CommonCancelButton">
                    Cancel
                </ng-container>
            </lib-button>
        </lib-submission-bar>
    </ng-container>
</lib-dialog-layout>
